// Route in webback.config.js
// /image-to-description

import { createApp } from 'vue';
import App from './ImageGenerator.vue';
import FontAwesomePlugin from '@/plugins/fontawesome';
import "@/styles/theme.css"



const app = createApp(App);

// Use Font Awesome Plugin
app.use(FontAwesomePlugin);

app.mount('#imageGenerator');

// Emit the render event after the app is mounted

setTimeout(() => {
    document.dispatchEvent(new Event('custom-render-trigger'));
    console.log('[Vue] Render event dispatched');
}, 5000);

// For debugging prerender
if (window.__PRERENDER_INJECTED) {
    console.log('[Vue] Running in prerender mode');
}
